import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-bg-page relative m-10 flex flex-col p-8',
    headerText:
      'text-s mb-5 flex flex-col leading-[1.5] font-semibold whitespace-pre-wrap max-lg:mb-3',
    resendText: 'mt-4',
    inputText: '',
    helperText: 'text-inactive min-h-6 pt-1 text-sm font-light opacity-0',
    loadingContainer:
      'bg-bg-items-white absolute top-0 left-0 flex size-full items-center justify-center',
    loading: 'loading bg-bg-items-white h-5 w-16 transform transition-opacity'
  },
  variants: {
    status: {
      completed: {
        helperText: 'text-success opacity-100',
        inputText: 'text-success'
      },
      error: {
        helperText: 'text-error opacity-100',
        inputText: 'text-error'
      },
      loading: {},
      default: {}
    }
  },
  defaultVariants: {}
});
